import { getDataFromLocalStorage } from "./localStorage";

const WHATSAPP_API_BASE_URL = "https://api.doclift.ai";

const authHeaders = () => {
  const token = getDataFromLocalStorage("token");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

const parseApiResponse = async (response) => {
  const rawBody = await response.text();
  const payload = rawBody ? JSON.parse(rawBody) : {};

  if (!response.ok || (payload.status && payload.status >= 400)) {
    const detail =
      typeof payload.detail === "string"
        ? payload.detail
        : payload.detail?.error?.message || payload.detail?.message;
    throw new Error(
      detail ||
        payload.error ||
        payload.message ||
        "Unable to complete WhatsApp request."
    );
  }

  return payload.data || payload;
};

export const fetchWhatsappConversations = async () => {
  const response = await fetch(`${WHATSAPP_API_BASE_URL}/wa-conversations`, {
    method: "GET",
    headers: authHeaders(),
  });

  const data = await parseApiResponse(response);
  const result = Array.isArray(data) ? data : data?.items || [];
  return result;
};

export const fetchWhatsappMessages = async (conversationId) => {
  const response = await fetch(
    `${WHATSAPP_API_BASE_URL}/wa-conversations/${conversationId}/messages`,
    {
      method: "GET",
      headers: authHeaders(),
    }
  );

  const data = await parseApiResponse(response);
  const messages = Array.isArray(data) ? data : data?.messages || [];
  return messages;
};

export const sendWhatsappReply = async (conversationId, body) => {
  const response = await fetch(
    `${WHATSAPP_API_BASE_URL}/wa-conversations/${conversationId}/reply`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ body }),
    }
  );

  return parseApiResponse(response);
};
